/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-west-1",
    "aws_cognito_identity_pool_id": "eu-west-1:013ae6fc-03ea-4c8b-ac66-3a6079fa5e3c",
    "aws_cognito_region": "eu-west-1",
    "aws_user_pools_id": "eu-west-1_a9a4pXDaJ",
    "aws_user_pools_web_client_id": "68fcs2ordcght9fllrteco0os3",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "reportsv01479dfcd2763446cd8a3c46396e311427120545-reports",
    "aws_user_files_s3_bucket_region": "eu-west-1"
};


export default awsmobile;
